import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import update from 'immutability-helper';
class ModalContent extends Component {

    constructor(props) {
        super(props);

        this.onChangeInput = this.onChangeInput.bind(this);
        this.renderTipoConteudo = this.renderTipoConteudo.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.setInitialState = this.setInitialState.bind(this);
        this.inserirConteudo = this.inserirConteudo.bind(this);

        this.state = {
        }
    }

    componentWillMount() {
        this.setInitialState();
    }

    setInitialState() {
        this.setState({
            objInputs: {
                idPoadcast: undefined,
                idEpsodio: undefined,
                idVideoPrograma: undefined,
                idVideoEpisodio: undefined,
                uri: undefined,
                titulo: undefined,
                descricao: undefined,
                uriImagem: undefined,
                idConteudo: undefined
            }
        })
    }

    onChangeInput(e) {
        const _name = e.target.name;
        this.setState({ [_name]: e.target.value });
    }

    renderTipoConteudo(tipo) {
        let _arrayRender = []
        switch (tipo) {
            case 2: //podcast
                _arrayRender = [
                    { label: 'idPodcast', nomeCampo: 'idPoadcast', type: 'number' },
                    { label: 'idEpisodio', nomeCampo: 'idEpsodio', type: 'number' }
                ];
                break;
            case 3: //vídeos
                _arrayRender = [
                    { label: 'idVideoPrograma', nomeCampo: 'idVideoPrograma', type: 'number' },
                    { label: 'idVideoEpisodio', nomeCampo: 'idVideoEpisodio', type: 'number' }
                ];
                break;

            case 4: //links
                _arrayRender = [
                    { label: 'Url do link', nomeCampo: 'uri', type: 'text' },
                    { label: 'Título', nomeCampo: 'titulo', type: 'text' },
                    { label: 'Descrição', nomeCampo: 'descricao', type: 'text' },
                    { label: 'Url da imagem', nomeCampo: 'urlImagem', type: 'text' }
                ];
                break;
            case 5: //arquivos
                _arrayRender = [
                    { label: 'Url do arquivo', nomeCampo: 'uri', type: 'text' },
                    { label: 'Título', nomeCampo: 'titulo', type: 'text' },
                    { label: 'Descrição', nomeCampo: 'descricao', type: 'text' },
                    { label: 'Url da imagem', nomeCampo: 'urlImagem', type: 'text' }
                ];
                break;
            default: //artigos
                _arrayRender = [
                    { label: 'idConteudo', nomeCampo: 'idConteudo', type: 'number' },
                ];
                break;
        }
        return _arrayRender
    }

    handleOnChange(e, campo) {
        this.setState({ objInputs: update(this.state.objInputs, { [campo]: { $set: e.target.value } }) })
    }

    toggle() {
        this.setInitialState();
        this.props.toggle();
    }

    inserirConteudo() {
        let _obj = this.state.objInputs;
        Object.keys(_obj).forEach(key => _obj[key] === undefined && delete _obj[key])
        this.props.inserirConteudo(_obj, this.props.tipo);
        this.toggle();
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle}>Inserir {this.props.label}</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12 py-1">
                            <div className="row no-gutters">
                                {this.renderTipoConteudo(this.props.tipo).map((item, index) => {
                                    return (
                                        <div key={index} className="col-12 py-2">
                                            <label>{item.label}</label>
                                            <input name="objInputs" type={item.type} className="form-control" onChange={(e) => this.handleOnChange(e, item.nomeCampo)} value={this.state.objInputs[item.nomeCampo]} autoComplete="off" />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="col-12 py-1 text-center">
                            <button onClick={this.inserirConteudo} className="btn btn-outline-success">inserir</button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

        )
    }
}

export default ModalContent;